import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8emw35kxrq: FaireBrandEntity = {
  token: "b_8emw35kxrq",
  type: "brand",
  name: "Mello.",
  avatarUrl:
    "https://cdn.faire.com/fastly/f1e039cb5359f2c57389be6de6aac3a063280a9a292c52e547f6182557a8ea4f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/21572378903596f42c581c17ef8f0a63060aa450be7f21392cda3af959766d5b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f1e039cb5359f2c57389be6de6aac3a063280a9a292c52e547f6182557a8ea4f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/21572378903596f42c581c17ef8f0a63060aa450be7f21392cda3af959766d5b.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 248,
  isTopShop: true,
  isInsider: true,
  description:
    "Mello is a wholesale supplier to boutiques across the world. \nAt the crossroads of fashion and innovation, we create styles through the inspiration of the world around us.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:56.340Z",
    importedBy: "entity-db-cli",
  },
};
